import { useStore } from 'vuex'

import merge from 'lodash/merge'

function trackEvent(event, value, callback) {
    // Ensure that the event category has a value
    if (typeof event !== 'undefined' && event !== '') {
        // Check if the data layer exists
        if (typeof dataLayer !== 'undefined') {
            const data = {
                event: event,
                CAMPAIGN_CODE: window.CAMPAIGN_CODE || null,
                APPLICATION_ID: window.APPLICATION_ID ?? value?.application_id ?? null,
                CAMPAIGN_INTEGRATION: window.CAMPAIGN_INTEGRATION || null,
            }

            if (process.env.IS_LENDINDTREE) {
                if (value?.application_id) {
                    delete value.application_id
                }

                value = additionalValues(value)
            }

            if (value !== 'undefined' && typeof value == 'object') {
                Object.assign(data, value)
            }

            if (typeof callback !== 'undefined') {
                data.eventCallback = callback
            }
            // Push the event to Google Tag Manager Data Layer
            dataLayer.push(data)
        }
    }
}

function additionalValues(value) {
    const store = useStore()

    if (!store) {
        return value
    }

    let values = []
    let keys = ['v1', 'v2', 'v3', 'v4', 'v5', 'v6', 'v7', 'v8', 'v9']
    let data = store.state.apply.data

    keys.forEach(key => {
        values[data[key].mappedKey] = data[key].value
    })

    return merge(value, values)
}

export { trackEvent }
